'use client'
import { Avatar } from '@/components/ui/avatar'
import { HStack, Text } from '@chakra-ui/react'
import React, { Suspense, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { IRedux } from '../../_store/types'
import { Link } from '@/i18n/navigation'
import HeaderLogo from '../HeaderLogo'
import { getHeaderLogoConfig } from '../../_utils/getHeaderLogoConfig'

const Logo = () => {
  const settings = useSelector((state: IRedux) => state.settings)
  const logoConfig = useMemo(
    () => getHeaderLogoConfig(settings?.data?.data),
    [settings?.data?.data]
  )

  return (
    <HStack alignItems='center' gap={2}>
      <Suspense fallback='BRAND'>
        <Link href='/'>
          <HeaderLogo config={logoConfig} variant='desktop' />
        </Link>
      </Suspense>
      {logoConfig.showBrandName && (
        <Text fontWeight='bold' color='text' fontSize='24px'>
          {logoConfig.shipperName}
        </Text>
      )}
    </HStack>
  )
}

export default Logo
